import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  AcademyModuleSelect,
  currentFiltersSelector,
  SBAT_GROUP_FILTERS,
  setFilterValue,
} from 'features/classCreation';
import { FILTER_TYPE } from 'data/filterType';
import Field from 'components/Field';

function AcademyModuleFilter({ sbatGroups }) {
  const dispatch = useDispatch();
  const { academyModules } = useSelector(currentFiltersSelector);

  const handleOnChange = useCallback(
    (option) => {
      dispatch(
        setFilterValue({
          key: SBAT_GROUP_FILTERS.academyModules,
          value: option,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );

  return (
    <Field
      label="Module Names"
      labelClassName="h5"
    >
      <AcademyModuleSelect
        sbatGroups={sbatGroups}
        value={academyModules}
        placeholder="Select from dropdown"
        onChange={handleOnChange}
      />
    </Field>
  );
}

export default AcademyModuleFilter;
